import React from 'react'
import PropTypes from 'prop-types'

import ProductAnalyticsTiers from './ProductAnalyticsTiers'

function ProductAnalyticsTiersContainer({
  tiersData, tierRule, tabSwitch, hr,
}) {
  return (
    <div>
      {hr && <hr className="is-dashed" />}
      <ProductAnalyticsTiers tiersData={tiersData} tierRule={tierRule} tabSwitch={tabSwitch} />
    </div>
  )
}

ProductAnalyticsTiersContainer.propTypes = {
  tiersData: PropTypes.object.isRequired,
  tierRule: PropTypes.number.isRequired,
  tabSwitch: PropTypes.func.isRequired,
  hr: PropTypes.bool,
}

ProductAnalyticsTiersContainer.defaultPropTypes = {
  hr: false,
}

export default ProductAnalyticsTiersContainer
